import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "rivaaz_admin_token";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (localStorage.getItem(TOKEN_KEY)) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      localStorage.setItem("rivaaz_admin_email", data.email);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || "Login failed";
      toast.error(typeof msg === "string" ? msg : "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20 md:py-28" data-testid="admin-login-page">
      <h1 className="font-display text-4xl md:text-5xl font-extrabold text-[#0E0E1A]">
        Staff sign-in
      </h1>
      <p className="text-[#57534E] mt-2">
        Restricted area. Manage incoming orders.
      </p>
      <form onSubmit={submit} className="mt-10 space-y-4" data-testid="admin-login-form">
        <label className="block">
          <span className="text-xs font-semibold tracking-wide uppercase text-[#57534E] mb-1.5 block">
            Email
          </span>
          <input
            data-testid="admin-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
            className="w-full bg-white border border-[#E7E5E4] rounded-xl px-4 py-3 focus:outline-none focus:border-[#C9853E]"
          />
        </label>
        <label className="block">
          <span className="text-xs font-semibold tracking-wide uppercase text-[#57534E] mb-1.5 block">
            Password
          </span>
          <input
            data-testid="admin-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full bg-white border border-[#E7E5E4] rounded-xl px-4 py-3 focus:outline-none focus:border-[#C9853E]"
          />
        </label>
        <button
          type="submit"
          disabled={submitting}
          data-testid="admin-login-submit"
          className="w-full inline-flex items-center justify-center gap-2 bg-[#C9853E] hover:bg-[#A6692D] disabled:opacity-60 text-white rounded-full px-6 py-3.5 font-bold transition-all"
        >
          {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
        </button>
      </form>
    </div>
  );
}
